export default "__VITE_ASSET__f7f00bf7__"